// src/Hu.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Hu_default = createIcon({
  displayName: "Hu",
  viewBox: "0 0 48 32",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        id: "green",
        y: "21",
        width: "48",
        height: "11",
        fill: "#1AAF5D"
      }),
      /* @__PURE__ */ jsx("rect", {
        id: "white",
        y: "11",
        width: "48",
        height: "10",
        fill: "white"
      }),
      /* @__PURE__ */ jsx("rect", {
        id: "red",
        width: "48",
        height: "11",
        fill: "#E94B35"
      })
    ]
  })
});

export {
  Hu_default
};
